/**
 * Subscription Options Component
 * Handles subscription frequency dropdown functionality
 */



// Initialize all subscription options on the page
document.addEventListener('DOMContentLoaded', () => { 
  const deliveryDateElement = document.querySelector('[data-delivery-date]');
  if (!deliveryDateElement) return;

  const today = new Date();
  let currentDate = new Date(today);
  currentDate.setDate(currentDate.getDate() + 1); // Empezar desde mañana (excluir día actual)
  let businessDaysCount = 0;
  const businessDaysNeeded = 5;

  // Avanzar día por día hasta contar 5 días hábiles
  while (businessDaysCount < businessDaysNeeded) {
    const dayOfWeek = currentDate.getDay(); // 0 = Domingo, 6 = Sábado
    
    // Si no es sábado (6) ni domingo (0), es un día hábil
    if (dayOfWeek !== 0 && dayOfWeek !== 6) {
      businessDaysCount++;
    }
    
    // Si aún no hemos alcanzado los 5 días hábiles, avanzar al siguiente día
    if (businessDaysCount < businessDaysNeeded) {
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  // Formatear la fecha como "Mon, Sep 26"
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  
  const dayName = days[currentDate.getDay()];
  const monthName = months[currentDate.getMonth()];
  const dayNumber = currentDate.getDate();
  
  deliveryDateElement.textContent = `${dayName}, ${monthName} ${dayNumber}`;
});

